@switch (nachrichtState) {

    @case (NachrichtStateEnum.FORM) {
        <kokos-nachricht-form
                scrollIntoView
                [nachrichtPayload]="nachrichtPayload"
                [anliegenName]="anliegenName"
                [betreffEditable]="false"
                [subanliegenName]="subanliegenName"
                [showUpload]="anhangErlaubt"
                [nachrichtHistorie]="nachrichtHistorie"
        ></kokos-nachricht-form>
    }
}
